
import actions from './actions'
import mutations from './mutations'

let state = {
    all: null
}

const ACTIONS = {
    GET_ALL: 'habilitations/getAll'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }